import React from 'react';
import classes from './Hero.module.scss';
import Hyperspeed from '../Hyperspeed/Hyperspeed';
import { FaShieldAlt, FaGlobe, FaRocket } from 'react-icons/fa';

// Import service icons
import mobileAppIcon from '../../assets/mobile_app_circle.png';
import aiMlIcon from '../../assets/ai_ml_circle.png';
import uiUxIcon from '../../assets/ui_ux_circle.png';
import webDevIcon from '../../assets/web_dev_circle.png';
import cloudDevOpsIcon from '../../assets/cloud_devops_circle.png';
import ecommerceIcon from '../../assets/ecommerce_development_circle.png';

const Hero = () => {
  return (
    <section id="hero" className={classes.hero}>
      <Hyperspeed />

      <div className={classes.container}>
        <div className={classes.content}>
          {/* Trust badge */}
          <div className={classes.trustBadge}>
            <FaShieldAlt className={classes.trustIcon} />
            <span>Trusted by 30+ businesses across 10+ industries</span>
          </div>

          {/* Headline */}
          <h1 className={classes.title}>
            Your Technology Partner
            <br />
            <span className={classes.gradient}>From Idea to Launch</span>
          </h1>

          {/* Subtitle — clear value proposition */}
          <p className={classes.subtitle}>
            We build Websites, Mobile Apps, and AI-powered products at globally
            competitive prices — without compromising on quality, speed, or
            scalability.
          </p>

          {/* Value props row */}
          <div className={classes.valueProps}>
            <div className={classes.valueProp}>
              <FaGlobe className={classes.vpIcon} />
              <div>
                <span className={classes.vpTitle}>Globally Competitive</span>
                <span className={classes.vpDesc}>Starting from just ₹999</span>
              </div>
            </div>
            <div className={classes.vpDivider} />
            <div className={classes.valueProp}>
              <FaRocket className={classes.vpIcon} />
              <div>
                <span className={classes.vpTitle}>Fast Delivery</span>
                <span className={classes.vpDesc}>Launch-ready in weeks</span>
              </div>
            </div>
            <div className={classes.vpDivider} />
            <div className={classes.valueProp}>
              <FaShieldAlt className={classes.vpIcon} />
              <div>
                <span className={classes.vpTitle}>End-to-End Support</span>
                <span className={classes.vpDesc}>Strategy to post-launch</span>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className={classes.cta}>
            <a href="#contact" className={classes.primaryBtn}>
              Start Your Project
            </a>
            <a href="#portfolio" className={classes.secondaryBtn}>
              See Our Work
            </a>
          </div>

          {/* Service icons */}
          <div className={classes.serviceIcons}>
            <img src={mobileAppIcon} alt="Mobile App Development" />
            <img src={aiMlIcon} alt="AI & Machine Learning" />
            <img src={uiUxIcon} alt="UI/UX Design" />
            <img src={webDevIcon} alt="Web Development" />
            <img src={cloudDevOpsIcon} alt="Cloud & DevOps" />
            <img src={ecommerceIcon} alt="E-commerce Development" />
          </div>

          {/* Stats bar */}
          <div className={classes.stats}>
            <div className={classes.stat}>
              <span className={classes.statNumber}>50+</span>
              <span className={classes.statLabel}>Projects Delivered</span>
            </div>
            <div className={classes.stat}>
              <span className={classes.statNumber}>30+</span>
              <span className={classes.statLabel}>Happy Clients</span>
            </div>
            <div className={classes.stat}>
              <span className={classes.statNumber}>10+</span>
              <span className={classes.statLabel}>Industries Served</span>
            </div>
            <div className={classes.stat}>
              <span className={classes.statNumber}>99%</span>
              <span className={classes.statLabel}>On-Time Delivery</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
